import validateExcludedEmailDomain from '~/components/page/Settings/LFASettings/utils/validateExcludedEmailDomain';

const isValidExcludedEmailDomain = (value: string): boolean =>
  validateExcludedEmailDomain(value).valid;

export default isValidExcludedEmailDomain;
